import React from "react"
import Faq from "react-faq-component"
import { Route, Switch } from "react-router-dom"
import { Container } from "react-bootstrap"
import { withWhiteLabelContext } from "react-whitelabel"
import { Link } from "react-router-dom"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Image from "react-bootstrap/Image"
import { routePaths } from "../../routes/routes"
import "./FaqListing.scss"

class FaqListing extends React.Component {
  state = {
    data: {
      title: "FAQ (How it works)",
      rows: [
        {
          title: "Lorem ipsum dolor sit amet,",
          content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sed tempor sem. Aenean vel turpis feugiat,
                ultricies metus at, consequat velit. Curabitur est nibh, varius in tellus nec, mattis pulvinar metus.
                In maximus cursus lorem, nec laoreet velit eleifend vel. Ut aliquet mauris tortor, sed egestas libero interdum vitae.
                Fusce sed commodo purus, at tempus turpis.`,
        },
        {
          title: "Nunc maximus, magna at ultricies elementum",
          content:
            "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam, vitae convallis ex tortor sed dolor.",
        },
        {
          title: "Curabitur laoreet, mauris vel blandit fringilla",
          content: `Curabitur laoreet, mauris vel blandit fringilla, leo elit rhoncus nunc, ac sagittis leo elit vel lorem.
              Fusce tempor lacus ut libero posuere viverra. Nunc velit dolor, tincidunt at varius vel, laoreet vel quam.
              Sed dolor urna, lobortis in arcu auctor, tincidunt mattis ante. Vivamus venenatis ultricies nibh in volutpat.
              Cras eu metus quis leo vestibulum feugiat nec sagittis lacus.Mauris vulputate arcu sed massa euismod dignissim. `,
        },
        {
          title: "What is the package version",
          content: <p>current version is 1.2.1</p>,
        },
      ],
    },
    styles: {
      // bgColor: 'white',
      titleTextColor: "blue",
      rowTitleColor: "blue",
      // rowContentColor: 'grey',
      // arrowColor: "red",
    },
    config: {
      // animate: true,
      // arrowIcon: "V",
      // tabFocus: true
    },
  }
  render() {
    return (
      <>
        <div className="faq-container">
          <Faq
            data={{
              title: "FAQs",
              rows: [
                {
                  title: "What is Limos.com?",
                  content: `Limos.com is a worldwide aggregator that helps find you the best deals for your transportation needs.`,
                },
                {
                  title: "What areas does Limos.com service?",
                  content:
                    "We are an aggregator with operators and fleet owners worldwide.",
                },
                {
                  title: "What vehicles do you offer?",
                  content: `Everything from luxury sedans, SUVs, party buses, limos, motorcoaches and pretty much everything in between. We offer multi-day and multi-vehicle options for any occasion. `,
                },
              ],
            }}
            styles={{
              // bgColor: 'white',
              titleTextColor: "black",
              rowTitleColor: "black",
              // rowContentColor: 'grey',
              // arrowColor: "red",
            }}
            config={{}}
          />
        </div>
      </>
    )
  }
}

export default FaqListing
